import { RouteType } from "types/RouteType";
import type { RootStore } from "stores/index";
import type CheckTemplateDesignerStore from "./CheckTemplateDesigner.Store";

/**
 * Check Template Designer Route
 *
 * Full-page template designer for configuring check layouts
 * with visual element positioning and real-time preview
 */
const checkTemplateDesignerRoute: RouteType = {
  name: "Check Template Designer",
  path: "/accounting/check-template-designer",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Check Template Designer",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./CheckTemplateDesigner.Header"),
    },
    body: {
      component: () => import("./CheckTemplateDesigner.Body"),
      grayBackground: false,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  showCompanySelector: true,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    rootStore.appLayoutStore?.initializeSelectedPlant();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const store = (rootStore as any)
      .checkTemplateDesignerStore as CheckTemplateDesignerStore;
    if (store) {
      await store.loadData();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const store = (rootStore as any)
      .checkTemplateDesignerStore as CheckTemplateDesignerStore;
    if (store) {
      await store.loadData();
    }
  },
  dialogs: [],
};

export default checkTemplateDesignerRoute;
